<template>
  <div>
    <!-- Assignment Split/Merge/Move Summary Section Start -->
    <div></div>
    <b-button
      v-if="PMC_JOBID > 0"
      class="mb-1 mt-1"
      @click="showSplitMergeModal(PMC_JOBID)"
      size="xs"
      style="font-size: 0.675rem"
      >{{ 'Split/Merge/Move Summary' }}</b-button
    >
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="split-merge-modal"
      hide-footer
      :title="(PMC_title+' - '+PMC_JOBNO) || 'Assignment Split/Merge/Move Summary'"
    >
      <!-- <CustomLoader v-if="isLoading" :width="70"></CustomLoader> -->
      <b-row>
        <b-col md="12">
          <!-- Summary Cards -->
          <div v-if="summaryData" class="mb-3">
            <b-row>
              <b-col md="3">
                <b-card class="text-center bg-primary text-white">
                  <h5>{{ summaryData.totalOperations || 0 }}</h5>
                  <small>Total Operations</small>
                </b-card>
              </b-col>
              <b-col md="3">
                <b-card class="text-center bg-success text-white">
                  <h5>{{ summaryData.splitCount || 0 }}</h5>
                  <small>Splits</small>
                </b-card>
              </b-col>
              <b-col md="3">
                <b-card class="text-center bg-warning text-white">
                  <h5>{{ summaryData.mergeCount || 0 }}</h5>
                  <small>Merges</small>
                </b-card>
              </b-col>
              <b-col md="3">
                <b-card class="text-center bg-info text-white">
                  <h5>{{ summaryData.moveCount || 0 }}</h5>
                  <small>Moves</small>
                </b-card>
              </b-col>
            </b-row>
          </div>

          <b-button
            class="pull-right mb-1"
            v-if="splitMergeList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getAssignmentSplitMergeData', 'Export As Excel')"
            size="xs"
            style="font-size: 0.675rem"
            variant="warning"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>

          <!-- Filter Tabs -->
          <b-nav tabs class="mb-2">
            <b-nav-item 
              :active="activeTab === 'all'" 
              @click="activeTab = 'all'"
            >
              All ({{ splitMergeList.length }})
            </b-nav-item>
            <b-nav-item 
              :active="activeTab === 'splits'" 
              @click="activeTab = 'splits'"
            >
              Splits ({{ splitsData.length }})
            </b-nav-item>
            <b-nav-item 
              :active="activeTab === 'merges'" 
              @click="activeTab = 'merges'"
            >
              Merges ({{ mergesData.length }})
            </b-nav-item>
            <b-nav-item 
              :active="activeTab === 'moves'" 
              @click="activeTab = 'moves'"
            >
              Moves ({{ movesData.length }})
            </b-nav-item>
          </b-nav>

          <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">
            <b-table
              show-empty
              stacked="md"
              :items="filteredData"
              :fields="splitMergeFields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
            >
              <template slot="SN" slot-scope="row0">
                <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
              </template>

              <template slot="operationType" slot-scope="row">
                <b-badge
                  :variant="getOperationTypeVariant(row.item.operationType)"
                  :class="getOperationTypeClass(row.item.operationType)"
                >
                  {{ row.item.operationType }}
                </b-badge>
              </template>

              <template slot="containerNo" slot-scope="row">
                <span class="font-weight-bold text-primary">{{ row.item.containerNo }}</span>
              </template>

              <template slot="operationDate" slot-scope="row">
                <span>{{ formatDateTime(row.item.operationDate) }}</span>
              </template>

              <template slot="performedBy" slot-scope="row">
                <div>
                  <strong>{{ row.item.performedBy }}</strong>
                  <br>
                  <small class="text-muted">{{ row.item.performedByCode }}</small>
                </div>
              </template>

              <template slot="customMessage" slot-scope="row">
                <div class="text-wrap" style="max-width: 300px;">
                  {{ row.item.customMessage }}
                </div>
              </template>
            </b-table>
          </div>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideSplitMergeModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import CommonService from "../../services/CommonService";
import NodeLockPannelService from "../../services/NodeLockPannelService";

export default {
  name: "AssignmentSplitMergeSummary",
//   components: {
//     CustomLoader,
//   },
  props: {
    PMC_title: {
      type: String,
      default: "Assignment Split/Merge/Move Summary",
    },
    PMC_JOBID: {
      type: [Number, String],
      default: 0,
    },
    PMC_JOBNO: {
      type: String,
      default: "",
    },
    PMC_JOBDATE: {
      type: String,
      default: "",
    },
    PMC_JOBTYPE: {
      type: String,
      default: "",
    },
    PMC_AgentType: {
      type: String,
      default: "",
    },
    PMC_Client: {
      type: String,
      default: "",
    },
    PMC_Sline: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      ExcelBtnName: "Export As Excel",
      splitMergeList: [],
      splitsData: [],
      mergesData: [],
      movesData: [],
      summaryData: null,
      activeTab: "all",
      perPage: 10,
      currentPage: 1,
      sortBy: "operationDate",
      sortDesc: true,
      sortDirection: "desc",
      splitMergeFields: [
        { key: "SN", mainkey: "SN", label: "SN.", sortable: true, sortDirection: "ASC", table: "A." },
        { key: "operationType", mainkey: "operationType", label: "Operation Type", sortable: true, sortDirection: "ASC", table: "B." },
        { key: "containerNo", mainkey: "containerNo", label: "Container No", sortable: true, sortDirection: "ASC", table: "C." },
        { key: "uniqueContainerId", mainkey: "uniqueContainerId", label: "Container ID", sortable: true, sortDirection: "ASC", table: "D." },
        { key: "allModuleId", mainkey: "allModuleId", label: "Assignment ID", sortable: true, sortDirection: "ASC", table: "E." },
        { key: "fromSplitMergeAssignNo", mainkey: "fromSplitMergeAssignNo", label: "From Assignment", sortable: true, sortDirection: "ASC", table: "F." },
        { key: "splitedToOrMergedToAssigNo", mainkey: "splitedToOrMergedToAssigNo", label: "To Assignment", sortable: true, sortDirection: "ASC", table: "G." },
        { key: "source_clientName", mainkey: "source_clientName", label: "Source Client", sortable: true, sortDirection: "ASC", table: "H." },
        { key: "target_clientName", mainkey: "target_clientName", label: "Target Client", sortable: true, sortDirection: "ASC", table: "I." },
        { key: "performedBy", mainkey: "performedBy", label: "Performed By", sortable: true, sortDirection: "ASC", table: "J." },
        { key: "operationDate", mainkey: "operationDate", label: "Operation Date", sortable: true, sortDirection: "ASC", table: "K." },
        { key: "customMessage", mainkey: "customMessage", label: "Description", sortable: false, sortDirection: "ASC", table: "L." },
      ],
    };
  },
  computed: {
    filteredData() {
      switch (this.activeTab) {
        case "splits":
          return this.splitsData;
        case "merges":
          return this.mergesData;
        case "moves":
          return this.movesData;
        default:
          return this.splitMergeList;
      }
    },
  },
  beforeMount() {
    if (this.PMC_JOBID) {
      // this.getSplitMergeData();
    }
  },
  methods: {
    showSplitMergeModal(jobId) {
      console.log("AssignmentSplitMergeSummary - showSplitMergeModal called with jobId:", jobId);
      this.getSplitMergeData("Normal");
    },
    hideSplitMergeModal() {
      this.$refs["split-merge-modal"].hide();
    },
    getSplitMergeData(type) {
      console.log("AssignmentSplitMergeSummary - getSplitMergeData called with type:", type);
      console.log("AssignmentSplitMergeSummary - PMC_JOBID:", this.PMC_JOBID);
      
      if (this.PMC_JOBID) {
        this.isLoading = true;
        const payload = {
          allModuleId: this.PMC_JOBID,
        };
        
        console.log("AssignmentSplitMergeSummary - API payload:", payload);
        
        NodeLockPannelService.getAssignmentSplitMergeData(payload)
          .then((response) => {
            console.log("AssignmentSplitMergeSummary - API response:", response);
            this.isLoading = false;
            if (response.data && response.data.success) {
              this.splitMergeList = response.data.data.all || [];
              this.splitsData = response.data.data.splits || [];
              this.mergesData = response.data.data.merges || [];
              this.movesData = response.data.data.moves || [];
              this.summaryData = response.data.summary || {};
              
              console.log("AssignmentSplitMergeSummary - Data loaded:", {
                total: this.splitMergeList.length,
                splits: this.splitsData.length,
                merges: this.mergesData.length,
                moves: this.movesData.length,
                summary: this.summaryData
              });
              
              if (type === "Normal") {
                this.$refs["split-merge-modal"].show();
              }
            } else {
              console.error("AssignmentSplitMergeSummary - API error:", response.data.message);
            }
          })
          .catch((error) => {
            console.error("AssignmentSplitMergeSummary - API error:", error);
            this.isLoading = false;
            this.$toastr.error("Error loading split/merge data");
          });
      }
    },
    getReports(itemCode, btnName) {
      console.log("AssignmentSplitMergeSummary - getReports called:", itemCode, btnName);
      this.ExcelBtnName = "Please Wait...";
      
      const payload = {
        allModuleId: this.PMC_JOBID,
        itemCode: itemCode,
      };
      
      CommonService.getAssignmentSplitMergeData(payload)
        .then((response) => {
          console.log("AssignmentSplitMergeSummary - Excel export response:", response);
          this.ExcelBtnName = "Export As Excel";
          
          if (response.data && response.data.success) {
            // Handle Excel file download
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `assignment_split_merge_${this.PMC_JOBID}_${new Date().toISOString().split('T')[0]}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } else {
            this.$toastr.error("Failed to export Excel file");
          }
        })
        .catch((error) => {
          console.error("AssignmentSplitMergeSummary - Excel export error:", error);
          this.ExcelBtnName = "Export As Excel";
          this.$toastr.error("Error exporting Excel file");
        });
    },
    getOperationTypeVariant(operationType) {
      switch (operationType) {
        case "SPLIT":
          return "success";
        case "MERGE":
          return "warning";
        case "MOVE":
          return "info";
        default:
          return "secondary";
      }
    },
    getOperationTypeClass(operationType) {
      switch (operationType) {
        case "SPLIT":
          return "badge-success";
        case "MERGE":
          return "badge-warning";
        case "MOVE":
          return "badge-info";
        default:
          return "badge-secondary";
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return "N/A";
      try {
        const date = new Date(dateTime);
        return date.toLocaleString();
      } catch (error) {
        return dateTime;
      }
    },
  },
};
</script>

<style scoped>
.table-wrapper-scroll-x {
  overflow-x: auto;
}

.my-custom-scrollbar {
  max-height: 500px;
  overflow-y: auto;
}

.badge-success {
  background-color: #28a745 !important;
}

.badge-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}

.badge-info {
  background-color: #17a2b8 !important;
}

.badge-secondary {
  background-color: #6c757d !important;
}

.text-wrap {
  word-wrap: break-word;
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// AssignmentSplitMergeSummary.vue?9fc4f14e